<!-- 图片管理页面的功能概述
1、本页面中，为图片显示预览放大功能，调用图片子组件，该组件就是图片显示功能
2、图片上传功能
3、所有图片上传都是上传文件，等客户保存指令，再保存到数据
4、保存到数据库后，图片uid 数组，集中返回到父组件
5、由父组件在行保存到数据库里 -->
<template>
  <div>
    <!-- {{ (show_type === '2') || (show_type === '3') }} -->
    <el-card v-if="show_type === '2' || show_type === '3'">
      <el-form ref="addFormRef" label-width="100px">
        <div class="tupian_show">
          <div>
            <el-upload :action="pic_upload_url" list-type="picture-card" :on-preview="handlePictureCardPreview" ref="upload" :on-remove="handleRemove" :headers="headerObj" :on-success="handleSuccess" :before-upload="handleBeforeUpload" :limit="maxCountPic" style="margin-bottom: 20px">
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
        </div>
      </el-form>
      <!-- <span slot="footer" class="dialog-footer">
                <el-button @click="addDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="addtuwen">确 定</el-button>
            </span> -->
    </el-card>
    <el-card v-if="show_type === '1' || show_type === '2'">
      <!-- {{ show_pics }} -->
      <img :src="item" alt="" style="height: 100px; width: 100px; margin-left: 5px" :key="index" v-for="(item, index) in show_pics" />
    </el-card>

    <el-dialog title="图片预览" :visible.sync="previewDialogVisible" width="50%">
      <img :src="previewPath" alt="" />
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ['show_type', 'picsUrl', 'max_count'], // picsUrl 显示图片用
  // show_type  1浏览 2 浏览+修改添加 3 修改添加
  data() {
    return {
      datekey: Date.now(),
      maxCountPic: 0,
      pic_upload_url: window.sessionStorage.getItem('http_api') + '/upload',
      headerObj: {
        Authorization: window.sessionStorage.getItem('token')
      },
      addForm: {
        pics: []
      },
      isUploadDisabled: false,
      show_pics: [],
      // 删除按钮是否可见
      // 获取图文信息列表参数
      queryInfo: {
        //   token: window.sessionStorage.getItem('token'), // 递交数据，必须携带token ，进行验证
        C_type: 'get_list',
        C_table_name: 'pic_list', // + this.tuwen_type,
        query: '',
        pageNum: 1,
        pageSize: 10
      },
      previewPath: '',
      previewDialogVisible: false
    }
  },
  created() {
    this.getPicList()

    this.maxCountPic = parseInt(this.max_count)
    //  this.update_show_pic()
    // console.log(this.tuwen_type, this.show_type, this.update_flag)
  },
  watch: {
    picsUrl: {
      handler(oldVal, newVal) {
        this.update_show_pic()
      }
    }
  },
  methods: {
    handleBeforeUpload(file) {
      const maxSize = 50 * 1024 * 1024 // 10MB
      if (file.size > maxSize) {
        this.$message.error('文件大小不能超过50MB')
        return false // 阻止上传
      }
      return true
    },
    update_show_pic() {
      console.log(9900, this.picsUrl, this.maxCountPic)
      if (this.picsUrl) {
        const t = this.picsUrl.split(',') // 进行分割
        this.show_pics = t.slice(0, t.length - 1)
      }
    },
    async clearUpload(callback) {
      if (this.show_type !== '1') this.$refs.upload.clearFiles()
      // callback(0)
    },
    async pics_toChar() {
      const obj2 = this.addForm.pics
      //  console.log(obj2.length, this.maxCountPic, 9980)
      if (obj2.length >= parseInt(this.maxCountPic)) {
        this.isUploadDisabled = true
        console.log('true')
      }
      // if (obj2.length > parseInt(this.maxCountPic)) this.$message.error('已经超过最大数量无法添加！')

      let picsUrl = ''
      await obj2.forEach(async (item, index) => {
        picsUrl = picsUrl + item.url + ','
        //  console.log(9000, index, item.url, item.temp_url)
        if (index === obj2.length - 1) {
          // console.log(999005, picsUrl)
          this.$emit('backPicUrl', picsUrl) // 发送到chanpin
        }
        // this.$nextTick(this.update_show_pic());
      })
    },
    handlePictureCardPreview(file) {
      // 图片放大浏览
      this.previewPath = file.response.url
      this.previewDialogVisible = true
    },
    handleRemove(file) {
      // 图片删除 返回
      // console.log(998, file)
      const filePath = file.response.temp_url
      // const i = this.addForm.pics.findIndex(x => console.log(999, x))
      const i = this.addForm.pics.findIndex((x) => x.temp_url === filePath)
      this.addForm.pics.splice(i, 1)
      // console.log(123, this.addForm.pics)
      this.pics_toChar()
    },
    handleSuccess(response) {
      // 图片递交成功，接口返回数据
      const picInfo = { url: window.sessionStorage.getItem('httpApiImg') + '/' + response.temp_url, temp_url: response.temp_url }
      this.addForm.pics.push(picInfo)
      // console.log(123, this.addForm.pics)
      this.pics_toChar()
    },
    // async savePicToDb(callback) {
    //     const obj2 = this.addForm.pics
    //     let picsUid = ''
    //     await obj2.forEach(async (item, index) => {
    //         // console.log(item)
    //         const data = {
    //             C_type: 'tuwen_pic_add',
    //             url: item.url,
    //             temp_url: item.temp_url,
    //             pic_tuwen_uid: 0
    //         }
    //         const { data: res02 } = await this.$http.post('api', data)
    //         picsUid = picsUid + JSON.parse(res02.data)[0].picsUid.toString() + ','
    //         if (index === obj2.length - 1) callback(picsUid)
    //     })
    //     // ************************
    //     // this.$message.success('添加成功');
    // },
    // async backPicAddr(callback) { // 返回图片路径
    //     const obj2 = this.addForm.pics
    //     let picsUrl = ''
    //     await obj2.forEach(async (item, index) => {
    //         picsUrl = toString() + item.url + ','
    //         console.log(799, picsUrl)
    //         if (index === obj2.length - 1) callback(picsUrl)
    //     })

    //     callback(this.addForm.pics)
    // },
    async getPicList() {
      const { data: res } = await this.$http.get('get_api', {
        params: this.queryInfo
      })
      console.log(JSON.parse(res.data))
      this.tuwenList = JSON.parse(res.data)[0].dataList

      if (!this.tuwenList) return
      this.tuwenList.forEach(function (item) {
        item.yong_flag = item.yong_flag === 1
      })

      this.total = JSON.parse(res.data)[0].total

      // console.log(this.total);
    },
    //  分页第一项下拉触发

    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.getPicList()
    },
    // 选择页数触发
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage
      this.getPicList()
    }
  }
}
</script>
<style lang="less" scoped>
.card_two {
  margin-top: 30px;
  box-shadow: none !important;
}

.el_row_two {
  margin-top: 30px;
}

.quill {
  height: 200px;
}

.tupian_show {
  display: flex;
  flex-direction: row;
  justify-content: left;
  margin-left: 100px;
}
</style>
